import { render, staticRenderFns } from "./RecoverPasswordModal.vue?vue&type=template&id=bfa1947e&scoped=true&"
import script from "./RecoverPasswordModal.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPasswordModal.vue?vue&type=style&index=0&id=bfa1947e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa1947e",
  null
  
)

export default component.exports